import React from "react";
import { NavLink } from "react-router-dom";
import { Container } from "react-bootstrap";

const Home = () => {
  return (
    <Container
      fluid
      className="d-flex flex-column justify-content-center align-items-center text-center vh-100"
    >
      <div className="mb-4">
        <img
          src="../scopewithin.png"
          alt="ScopeWithin Logo"
          className="home-logo"
        />
      </div>
      <div>
        <NavLink to="/main" className="welcome-box">
          Welcome to ScopeWithin
        </NavLink>
      </div>
    </Container>
  );
};

export default Home;
